import {
  FetchOptions,
  realtimeQuery,
} from '@/lib/realtime/weak/realtimeFunctions';
import {
  EntityInstance,
  EntityInterfaceMap,
  WSEntityName,
} from '@/lib/realtime/weak/realtimeTypes';
import { WeakEntityRepositoryResponse } from '@/lib/realtime/weak/WeakEntityRepository';
import { getEntity } from '@/util/entityFunctions';
import { computed, ComputedRef, unref, WatchSource } from 'vue';

export const useRealtimeQueryById = <T extends WSEntityName>(
  entityName: T,
  id: WatchSource<number> | number,
  options: FetchOptions<T> = {},
  queryGetter: (
    id: EntityInstance<T>['id'],
    opts: FetchOptions<T>,
  ) => WeakEntityRepositoryResponse<EntityInterfaceMap, T> = (id, opts) =>
    realtimeQuery(entityName)
      .where('id' as keyof EntityInstance<T>, 'eq', id)
      .fetch(opts),
): {
  entity: ComputedRef<EntityInstance<T>>;
  response: ComputedRef<WeakEntityRepositoryResponse<EntityInterfaceMap, T>>;
} => {
  const idRef = computed(
    () =>
      unref(typeof id === 'function' ? id() : id) as EntityInstance<T>['id'],
  );
  const response = computed(() => queryGetter(idRef.value, options));
  const entity = computed(() =>
    getEntity(idRef.value, response.value.data, 'id'),
  );

  return { entity, response };
};
